import { Link, Outlet, useLocation } from 'react-router-dom';
import { brandingStyle, resolveBranding } from '../branding';
import { useI18n } from '../i18n/i18n-provider';
import { LocaleSwitch } from '../components/locale-switch';
import { PublicAnalyticsObserver } from '../analytics/public-analytics-observer';
import { OrganizationPwaMetadataSync } from '../pwa/organization-pwa-metadata';
import { PwaStatus } from '../pwa/pwa-status';
import {
  pickDefaultLandingForRoles,
  useSession,
} from '../session/session-provider';

export function RootLayout() {
  const { t } = useI18n();
  const { isAuthenticated, user } = useSession();
  const location = useLocation();
  const continueTo = user ? pickDefaultLandingForRoles(user.roles) : '/signin';
  const branding = resolveBranding();
  const isWorkspaceRoute = /^\/(attendee|admin|platform|account|help)(\/|$)/.test(location.pathname);
  const isOrganizationPublicRoute = /^\/o\/[a-z0-9][a-z0-9-]{0,62}\/?$/i.test(location.pathname);

  if (/^\/signin\/?$/.test(location.pathname)) {
    return <div className="app-shell--signin"><PublicAnalyticsObserver /><OrganizationPwaMetadataSync /><Outlet /></div>;
  }

  if (isWorkspaceRoute) {
    return <><PublicAnalyticsObserver /><OrganizationPwaMetadataSync /><Outlet /></>;
  }

  if (isOrganizationPublicRoute) {
    return <div className="app-shell app-shell--organization-public"><PublicAnalyticsObserver /><OrganizationPwaMetadataSync />
      <main className="app-main"><Outlet /></main></div>;
  }

  return (
    <div
      className="app-shell app-shell--public"
      data-brand={branding.key}
      style={brandingStyle(branding)}
    >
      <PublicAnalyticsObserver />
      <OrganizationPwaMetadataSync />
      <PwaStatus />
      <header className="app-header app-header--public">
        <Link to="/" className="app-brand" aria-label={t('app.name')}>
          <img src="/pwa/event-app-192-v1.png" width="48" height="48" alt="" />
          <span className="app-brand__lockup">
            <span className="app-brand__name">{t('app.name')}</span>
            <span className="app-brand__meta">{t('app.tagline')}</span>
          </span>
        </Link>
        <div className="app-header__tools">
          <LocaleSwitch />
          <Link to={continueTo} className="cta cta--secondary cta--compact">
            {isAuthenticated ? t('nav.continue') : t('auth.signIn')}
          </Link>
        </div>
      </header>
      <main className="app-main">
        <Outlet />
      </main>
      <footer className="app-footer">
        <span>{t('app.tagline')}</span>
        <Link to="/privacy/analytics">{t('publicAnalytics.footer')}</Link>
      </footer>
    </div>
  );
}
